module.exports = __webpack_public_path__ + "img/save-mind.6e682f53.svg";